export default {
    "viewslist": "Lekérdezések",
    "viewslistSubmit": "Futtatás",
    "displayName": "Lekérdezések",
    "id": "Lekérdezések",
    "successfulDownload": "A lekérdezés sikeresen végre lett hajtva."
};